// extracted by mini-css-extract-plugin
export default {"typeahead":"SubtitleForm_typeahead__K+DRW"};